import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { AprState } from "@reducers/types/HRM/apr-state";

import {
  createAprRequest,
  deleteAprRequest,
  getAprRequest,
} from "@actions/HRM/employee/apr-actions";
import { getAprState } from "@selectors/HRM/employee/apr-selector";

import { useAppSelector } from "@helpers/redux";
import { AprType } from "@type/HRM/apr";

interface UseApr {
  createAPR: (newApr: AprType) => void;
  deleteAPR: (aprId: number) => void;
  reports: AprType[];
  getAprRequestOngoing: boolean;
  getAprSuccess: boolean;
  getAprFailed: boolean;
  createAprRequestOngoing: boolean;
  createAprSuccess: boolean;
  createAprFailed: boolean;
  deleteAprRequestOngoing: boolean;
  deleteAprSuccess: boolean;
  deleteAprFailed: boolean;
}

export const useApr = (id: number | null): UseApr => {
  const dispatch = useDispatch();

  const {
    data: reports,
    getAprRequestOngoing,
    getAprSuccess,
    getAprFailed,
    createAprRequestOngoing,
    createAprSuccess,
    createAprFailed,
    deleteAprRequestOngoing,
    deleteAprSuccess,
    deleteAprFailed,
  } = useAppSelector<AprState>(getAprState);

  //GET
  useEffect(() => {
    if (id) dispatch(getAprRequest(id));
  }, [dispatch, id]);

  //CREATE NEW APR
  const createAPR = (data: AprType) =>
    dispatch(
      createAprRequest({
        employeeId: id,
        ...data,
      })
    );

  // DELETE APR
  const deleteAPR = (aprId: number) => {
    dispatch(
      deleteAprRequest({
        employeeId: id,
        aprId,
      })
    );
  };

  return {
    reports,
    getAprRequestOngoing,
    getAprSuccess,
    getAprFailed,
    createAprRequestOngoing,
    createAprSuccess,
    createAprFailed,
    deleteAprRequestOngoing,
    deleteAprSuccess,
    deleteAprFailed,
    createAPR,
    deleteAPR,
  };
};
